//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//

import { PhraseExtension } from "./PhraseOutput";

/**
 * The simple options configuration
 */
export interface SimpleOptions {
    /**
     * The extensions
     */
    extensions?: PhraseExtension[];
}
